<template>
  <span class="inline-block rounded-full"></span>
</template>
